<script>
import useSharedData from "@/use/SharedData.js";
import useValidation from "@/use/Validation.js";
import useTools from "@/use/Tools.js";
import {onMounted, ref} from "vue";
import useSharedMethod from "@/use/SharedMethod.js";
import axios from "axios";

export default {
    
    setup() {
        const {mxRules} = useValidation();
        const {loading, dialog} = useSharedData();
        const {$route, $refs} = useTools();
        const {getBack} = useSharedMethod();
        
        const recruitmentRequest = ref({});
        
        function findById(id) {
            loading.value = true;
            axios.get(`/recruitmentRequests/${id}`).then((response) => {
                recruitmentRequest.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function apply() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put('/recruitmentRequests/', recruitmentRequest.value).then(() => {
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        
        onMounted(() => findById($route.params.id));
        
        return {
            recruitmentRequest,
            mxRules,
            loading,
            dialog,
            apply,
            getBack,
        };
    },
};
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="700"
        scrollable
    >
        <v-card>
            <w-toolbar
                color="teal"
                :title="`${$t('recruitment_request.apply')} ${recruitmentRequest.occupationName}`"
            />
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <w-label :label="$t('recruitment_request.cv')" required/>
                                <w-file-input
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('recruitment_request.motivation_letter')"/>
                                <w-file-input/>
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.comment')"/>
                                <w-simple-text-area
                                
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    color="teal"
                    icon="mdi-briefcase-plus-outline"
                    :loading="loading"
                    :text="$t('recruitment_request.apply')"
                    @press="apply"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
